import { ChangeEvent, FunctionComponent, useEffect, useRef } from "react";
import { observer } from "mobx-react-lite";

import { Toast } from "primereact/toast";

import { faFileCirclePlus } from "@fortawesome/pro-regular-svg-icons";

import { useStore } from "../../../../stores/StoreContext";
import { useFileGroundingValidation } from "./useFileGroundingValidation";

import "./FileSelector.scss";

import { ActionButton } from "../../../../components/Shared";

interface IFileSelectorProps {
  allowedFileTypes: string[];
  allowedFileSize: number;
  allowedTotalFileSize: number;
  disabled?: boolean;
}

const FileSelectorComponent: FunctionComponent<IFileSelectorProps> = ({
  allowedFileTypes,
  allowedFileSize,
  allowedTotalFileSize,
  disabled,
}) => {
  const { chatStore } = useStore();

  const { addFiles, errorToastRef } = useFileGroundingValidation({
    allowedFileTypes,
    allowedFileSize,
    allowedTotalFileSize,
  });

  const fileInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (chatStore.selectedFiles.length === 0 && fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }, [chatStore.selectedFiles.length]);

  const handleFileSelect = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files) {
      return;
    }

    addFiles(files);

    event.target.value = "";
  };

  return (
    <>
      <Toast ref={errorToastRef} position="top-center" />

      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept={allowedFileTypes.join(",")}
        multiple
        disabled={disabled}
        onChange={handleFileSelect}
      />

      <ActionButton
        id="uploadFileInThreadButton"
        icon={faFileCirclePlus}
        hideBackground={true}
        hideBackgroundHover={true}
        buttonDisabled={disabled}
        tooltipDisabled={false}
        onClick={() => fileInputRef.current?.click()}
      />
    </>
  );
};

export const FileSelector = observer(FileSelectorComponent);
